import { useEffect, useRef } from 'react'
import { NOOP } from '../constants/global'
import { useDebounce } from './functions'

export const activityEvents = ['mousedown', 'keydown', 'touchstart', 'mousemove']

const useInactivityTimer = (
  actionOnInactive: Function = NOOP,
  timeout: number = 30 * 60 * 1000,
  immediate = false
) => {
  const timeoutId = useRef(null)

  const debouncedActivityHandler = useDebounce(
    () => {
      clearTimeout(timeoutId.current)
      timeoutId.current = setTimeout(actionOnInactive, timeout)
    },
    500,
    immediate
  )

  useEffect(() => {
    activityEvents.forEach((eventName) =>
      window.addEventListener(eventName, debouncedActivityHandler)
    )

    if (!timeoutId.current) {
      timeoutId.current = setTimeout(actionOnInactive, timeout)
    }

    return () => {
      clearTimeout(timeoutId.current)
      timeoutId.current = null
      activityEvents.forEach((eventName) =>
        window.removeEventListener(eventName, debouncedActivityHandler)
      )
    }
  }, [timeout, actionOnInactive, debouncedActivityHandler])
}

export default useInactivityTimer
